import { Grid, TextField } from '@material-ui/core';
import { FastField } from 'formik';
import React, { useCallback } from 'react';
import { formatPhone } from '../../helpers/phoneUtils';

const PhoneTextField = ({ field, meta, form, name, helperText, ...props }) => {
    const handleBlur = useCallback(
        e => {
            field.onBlur(e);
            if (field.value) {
                const formatted = formatPhone(field.value);
                if (formatted !== field.value) {
                    form.setFieldValue(name, formatted);
                }
            }
        },
        [field.value, field.onBlur, form.setFieldValue, name]
    );

    return (
        <TextField
            {...field}
            {...props}
            type="tel"
            onBlur={handleBlur}
            error={meta.error && meta.touched}
            helperText={(meta.touched && meta.error) || helperText}
            fullWidth
        />
    );
};

const FormikPhoneInput = ({ name, helperText, xs, sm, ...props }) => (
    <Grid item xs={xs ?? 12} sm={sm ?? 6}>
        <FastField name={name}>
            {({ field, meta, form }) => (
                <PhoneTextField
                    field={field}
                    meta={meta}
                    form={form}
                    name={name}
                    helperText={helperText}
                    {...props}
                />
            )}
        </FastField>
    </Grid>
);

export default FormikPhoneInput;
